function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.59375 0.25C7.875 0 8.3125 0 8.59375 0.25L15.8438 6.75C16.1562 7.03125 16.1875 7.5 15.9062 7.8125C15.625 8.125 15.1562 8.15625 14.8438 7.875L14.5938 7.65625V14.0625C14.5938 15.1562 13.6875 16.0625 12.5938 16.0625H3.59375C2.5 16.0625 1.59375 15.1562 1.59375 14.0625V7.65625L1.34375 7.875C1.03125 8.15625 0.5625 8.125 0.28125 7.8125C0 7.5 0.03125 7.03125 0.34375 6.75L7.59375 0.25ZM8.09375 1.8125L3.09375 6.3125V14.0625C3.09375 14.3438 3.3125 14.5625 3.59375 14.5625H5.09375V11.3125C5.09375 10.0625 6.09375 9.0625 7.34375 9.0625H8.84375C10.0938 9.0625 11.0938 10.0625 11.0938 11.3125V14.5625H12.5938C12.875 14.5625 13.0938 14.3438 13.0938 14.0625V6.3125L8.09375 1.8125ZM6.59375 14.5625H9.59375V11.3125C9.59375 10.9062 9.25 10.5625 8.84375 10.5625H7.34375C6.9375 10.5625 6.59375 10.9062 6.59375 11.3125V14.5625Z",
  fill: "#636766"
});

function SvgSearchHouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchHouse);
export default __webpack_public_path__ + "static/media/search-house.4fe2b6bf.svg";
export { ForwardRef as ReactComponent };